import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';

interface ReorderDataHooks {
  dataHookFrom: string;
  dataHookTo: string;
}

export interface SortableListBaseUniDriver extends BaseUniDriver {
  reorder: (dataHooks: ReorderDataHooks) => Promise<void>;
  getItemPosition: (itemDetails: { dataHook: string }) => Promise<number>;
}
